export type ProtocolView = 'classic' | 'grouped';
export const PROTOCOL_VIEW_KEY = 'it-ski.protocol-view.v1';

// Only a display preference lives in browser storage, never project data or drafts.
export function readProtocolView(storage?: Pick<Storage, 'getItem'>): ProtocolView {
  try {
    const value = (storage ?? window.localStorage).getItem(PROTOCOL_VIEW_KEY);
    return value === 'grouped' ? 'grouped' : 'classic';
  } catch {
    return 'classic';
  }
}

export function writeProtocolView(view: ProtocolView, storage?: Pick<Storage, 'setItem'>): void {
  try {
    (storage ?? window.localStorage).setItem(PROTOCOL_VIEW_KEY, view);
  } catch {
    // Private/restricted browsers still support switching for the current session.
  }
}
